import styled from '@emotion/styled';

export const Container = styled.div((props) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: props.theme.spacing(3),
  backgroundColor: props.theme.colors.pageWrapper,
}));

export const SubContainer = styled.div((props) => ({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  gap: props.theme.spacing(2),
}));

export const Item = styled.div(() => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: 20,
  width: '100%',
}));

export const ItemName = styled.div((props) => ({
  width: 170,
  minWidth: 150,
  color: props.theme.colors.inactive,
  fontSize: 13,
  fontWeight: 400,
}));

export const ItemValue = styled.div(() => ({
  fontSize: 13,
  height: 15,
  fontWeight: 400,
}));

export const UniqueItemValue = styled(ItemValue)((props) => ({
  fontSize: 14,
  fontFamily: props.theme.fonts.secondary,
}));

export const SectionWrapper = styled.div(() => ({
  display: 'flex',
  padding: 10,
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: 15,
  alignSelf: 'stretch',
}));
